import {UserAlerts} from "zavadil-ts-common";
import {createContext, useContext} from "react";

export const UserAlertsContext = createContext<UserAlerts>(new UserAlerts());

export function useAlerts(): UserAlerts {
	return useContext(UserAlertsContext);
}
